import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './SliderCard.module.css';

import { ReactComponent as SpectaclesIcon } from 'icons/spectacle.svg';
import { ReactComponent as ConcertIcon } from 'icons/concert.svg';

export default function SliderCard({ name, plage_date, plage_date_part1, plage_date_part2, poster, typeShow, link }) {
  const eventType = typeShow?.code === 'spectacle' ? 'spectacle' : 'concert';
  const ariaLabel = `Voir les détails du ${eventType} ${name}${plage_date ? ` du ${plage_date}` : ''}`;
  
  return (
    <Link to={link} className={styles.card} aria-label={ariaLabel}>
      <div className={styles.imageWrapper}>
        <img
          src={poster?.path || '/images/card/card-no-image.jpg'}
          alt={`Image de ${name}`}
          className={styles.image}
        />
        <div className={styles.topInfo}>
          {typeShow?.code === 'spectacle' && (<>
            <span className={`${styles.date}`}>{plage_date_part1}<br />{plage_date_part2}</span>
            <span className={`${styles.badge} ${styles.badgeSpectacle}`}><SpectaclesIcon className={styles.icon} /></span>
          </>
          )}
          {typeShow?.code === 'concert' && (<>
            <span className={`${styles.date} ${styles.dateConcert}`}>{plage_date_part1}<br />{plage_date_part2}</span>
            <span className={`${styles.badge} ${styles.badgeConcert}`}><ConcertIcon className={styles.icon} /></span>
          </>
          )}
        </div>

        {/*{plage_date && <div className={styles.date}>{plage_date}</div>}*/}
        {/*{typeShow?.code === 'spectacle' && (*/}
        {/*    <div className={`${styles.badge} ${styles.spectacle}`}>*/}
        {/*        <SpectaclesIcon className={styles.icon} />*/}
        {/*    </div>*/}
        {/*)}*/}
        {/*{typeShow?.code === 'concert' && (*/}
        {/*    <div className={`${styles.badge} ${styles.concert}`}>*/}
        {/*        <ConcertIcon className={styles.icon} />*/}
        {/*    </div>*/}
        {/*)}*/}
      </div>
      <div className={styles.title}>{name}</div>
    </Link>
  );
}

SliderCard.propTypes = {
  name: PropTypes.string.isRequired,
  plage_date: PropTypes.string,
  plage_date_part1: PropTypes.string,
  plage_date_part2: PropTypes.string,
  poster: PropTypes.shape({
    path: PropTypes.string,
  }),
  typeShow: PropTypes.shape({
    code: PropTypes.string,
  }),
  link: PropTypes.string.isRequired,
};
